<template>
  <div class="common-container">
    <div class="inquiry">
      <div class="title">我要查询</div>
      <inquiry-tool/>
    </div>
  </div>
</template>

<script>
import InquiryTool from "./components/Tool.vue";

export default {
  name: "Inquiry",
  components: {InquiryTool}
}
</script>

<style scoped lang="scss">
.inquiry {
  width: 1200px;
  padding: 30px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #2D2D2D;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 30px;
  }
}
</style>